import React from 'react';
import {BrowserRouter as Router,Routes,Route} from "react-router-dom";
import Dashboard from './screens/Dashboard';
import AnalyticsPage from './screens/AnalyticsPage';
import BonafideTemplate from "./components/BonafideTemplate";
import StudentPage from "./screens/StudentPage";
import CompleteClassDetails from './screens/CompleteClassDetails';
import StudentDetailsContextProvider from './store/student-details';
import Bonafide from "./screens/Bonafide";
import ReceiptPage from "./screens/ReceiptPage";
import ReceiptPageComponent from './components/ReceiptPage';
import ExamsScreen from './screens/ExamsScreen';
import ViewStudentMarks from './components/ViewStudentMarks';
import PrivacyPolicy from './screens/PrivacyPolicy';
import DeleteAccountInstructions from './screens/DeleteAccountInstructions';
import DataDeletionSteps from './screens/DataDeletionSteps';
import FeeDetails from './screens/FeeDetails';
import ViewFeeDetails from './screens/ViewFeeDetails';
import UploadAttendance from './screens/UploadAttendance';
const App = () => {

  return (
    <>
  <StudentDetailsContextProvider>
  <Router>
    <Routes>
      <Route exact path="/receiptPage" Component={ReceiptPageComponent}/>
      <Route exact path="/students" Component={StudentPage}/>
      <Route exact path="/" Component={Dashboard}/>
      <Route exact path="/analytics" Component={AnalyticsPage}/>
      <Route exact path="/viewMore/:className" Component={CompleteClassDetails}/>
      <Route exact path="/bonafide" Component={Bonafide}/>
      <Route exact path="/receipt" Component={ReceiptPage}/>
      <Route exact path="/exams" Component={ExamsScreen}/>
      <Route exact path="/viewMarks" Component={ViewStudentMarks}/>
      <Route exact path="/privacyPolicy" Component={PrivacyPolicy}/>
      <Route exact path="/generateBonafide/from/:fromYear/to/:toYear/leavingYear/:leavingYear" Component={BonafideTemplate}/>
      <Route exact path = "/accountDeletionInstructions" Component={DeleteAccountInstructions}/>
      <Route exact path = "/DataDeletionSteps" Component={DataDeletionSteps}/>
      <Route exact path = "/FeeDetails" Component={FeeDetails}/>
      <Route exact path = "/ViewFeeDetails" Component={ViewFeeDetails}/>
      <Route exact path="/uploadAttendance" Component={UploadAttendance}/>
    </Routes>
  </Router>
  </StudentDetailsContextProvider>
    </>
  )
}

export default App